<div *ngIf="isDesktop||isTablet">
  <mat-grid-list [cols]="cols" rowHeight="100px" class="banner">

    <mat-grid-tile>
      <a class="logo" href="https://ecsa.sa.gov.au" target="_blank" rel="noopener" style="position: absolute; left: 5px;">
        <img src="../assets/logo-mobile.svg" style="height: 80px;" alt="Electoral Commission South Australia">
      </a>
    </mat-grid-tile>

    <mat-grid-tile>
      <div>
        <div class="title" style="text-align: center;">
          South Australian Election Results
        </div><br/>
        <div class="sub-title" style="text-align: center;">{{subTitle}}</div>
      </div>
    </mat-grid-tile>

  </mat-grid-list>
</div>

<div *ngIf="isMobile">
  <mat-grid-list [cols]="6" rowHeight="60px" class="banner">

    <mat-grid-tile class="logoTile" colspan = 1 >
      <div class="hamburger">
        <button mat-icon-button (click)="toggleSideNav()">
          <mat-icon>menu</mat-icon>
        </button>
      </div>
    </mat-grid-tile>

    <mat-grid-tile colspan = 3>
      <div>
        <div class="title-phone" style="text-align: center; padding-bottom: 2px;">
          South Australian Election Results
        </div>
        <div class="sub-title-phone" style="text-align: center;">{{subTitle}}</div>
      </div>
    </mat-grid-tile>

    <mat-grid-tile colspan = 2>
      <a class="logo" href="https://ecsa.sa.gov.au" target="_blank" rel="noopener" style="position: absolute; left: 5px;">
        <img src="../assets/logo-mobile.svg" style="height: 45px;" alt="Electoral Commission South Australia">
      </a>
    </mat-grid-tile>

  </mat-grid-list>
</div>

<mat-sidenav-container *ngIf="isMobile" class="ecsa-sidnav-container-phone">
  <mat-sidenav role="navigation"
    class="sideMenu"
    [fixedInViewport]="optionsPhone.fixed"
    [fixedTopGap]="optionsPhone.top"
    [fixedBottomGap]="optionsPhone.bottom"
    [(opened)]="showSideNav">
    <app-side-menu></app-side-menu>
  </mat-sidenav>
  <mat-sidenav-content >
    <div *ngIf="currentPage===PageTypeEnum.Loading">
      <app-page-loading></app-page-loading>
    </div>
    <div *ngIf="currentPage===PageTypeEnum.CountDown">
      <app-count-down></app-count-down>
    </div>
    <div *ngIf="currentPage===PageTypeEnum.CountHAStateWide">
      <app-page-ha-summary></app-page-ha-summary>
    </div>
    <div *ngIf="currentPage===PageTypeEnum.CountHADistrict">
      <app-page-ha-district></app-page-ha-district>
    </div>
    <div *ngIf="currentPage===PageTypeEnum.CountLCStateWide">
      <app-page-lc-summary></app-page-lc-summary>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<mat-sidenav-container *ngIf="isDesktop||isTablet" fxFlexFill class="ecsa-sidnav-container">
  <mat-sidenav role="navigation"
    class="sideMenu" opened mode="side"
    [fixedInViewport]="options.fixed"
    [fixedTopGap]="options.top"
    [fixedBottomGap]="options.bottom"
    [style.maxWidth]="'400px'"
    [style.width]="'25%'">
    <app-side-menu></app-side-menu>
  </mat-sidenav>
  <mat-sidenav-content>
    <div *ngIf="currentPage===PageTypeEnum.Loading">
      <app-page-loading></app-page-loading>
    </div>
    <div *ngIf="currentPage===PageTypeEnum.CountDown">
      <app-count-down></app-count-down>
    </div>
    <div *ngIf="currentPage===PageTypeEnum.CountHAStateWide">
      <app-page-ha-summary></app-page-ha-summary>
    </div>
    <div *ngIf="currentPage===PageTypeEnum.CountHADistrict">
      <app-page-ha-district></app-page-ha-district>
    </div>
    <div *ngIf="currentPage===PageTypeEnum.CountLCStateWide">
      <app-page-lc-summary></app-page-lc-summary>
    </div>

  </mat-sidenav-content>
</mat-sidenav-container>

<!-- <mat-toolbar class="ecsa-footer"></mat-toolbar> -->
